"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var use_config_1 = require("./use-config");
function withConfig(WrappedComponent) {
    return react_1.default.forwardRef(function (props, ref) {
        var config = use_config_1.useConfig();
        return react_1.default.createElement(WrappedComponent, tslib_1.__assign(tslib_1.__assign({}, props), { ref: ref, config: config }));
    });
}
exports.withConfig = withConfig;
//# sourceMappingURL=with-config.js.map